import React from 'react';
import CheckedItem from './checked.item';
import { ChecklistContainer } from './checklist.styles';

interface ChecklistProps {
  items: {
    checked: boolean;
    text?: string;
  }[]
}

const Checklist = ({ items }: ChecklistProps): JSX.Element => {
  return (
    <ChecklistContainer>
      {
        items.map((item, index) => (
          <CheckedItem checked={item.checked} text={item.text} key={index}/>
        ))
      }
    </ChecklistContainer>
  )
}

export default Checklist;
